import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-analytics"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 13.9991L11 8.99907L15 12.9991C15.4204 12.5787 16.5485 11.4531 17.7149 10.2897M19.3067 8.70206L21.0037 7.00977C21.0037 7.00977 20.2691 7.7422 19.3067 8.70206ZM19.3067 8.70206L19.303 8.70571M19.303 8.70571C18.8105 9.1969 18.2585 9.74742 17.7149 10.2897M19.303 8.70571L17.7149 10.2897M17 7H21V11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartAnalytics = Vue.extend<IconProps>({
  name: 'ChartAnalyticsIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chart-analytics',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChartAnalytics;
